export const isActivePathname = (pathname: string, href: string) => {
    return href === '/'
        ? pathname === '/'
        : pathname.startsWith(href);
};
